<template>
    <FormCard>
        <template #cardTitle>
            PERSONAL INFORMATION
        </template>
        <template #cardSubtitle>
            This is automatically filled-out by the system. If you think there are issues with these information, please contact <a href="https://www.hmi.com.ph/contact">HMI</a>.
        </template>
        <template #cardText>
            <v-text-field
                label="NAME:"
                :value="getInfo.NAME"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="SEX:"
                :value="getInfo.SEX"
                color="teal"
                readonly
                autocomplete="nope"
            />
            <v-text-field
                label="DATE OF BIRTH:"
                :value="getInfo.F_BIRTHDATE"
                color="teal"
                readonly
                autocomplete="nope"
            />
        </template>
    </FormCard>
</template>

<script>
import FormCard from './Other/FormCard.vue'

export default {
    components: {
        FormCard
    },
    props: ['getInfo']
}
</script>
